import { FormEvent, MouseEvent } from 'react';
import { Button, ButtonGroup, Col, ControlLabel, Form, FormControl, FormGroup, Row, Well } from 'react-bootstrap'

interface IProps {
    alias: string,
    statusList: string[],
    typeList: string[],
    onAliasChange: (alias: string) => void,
    onStatusListChange: (list: string[]) => void,
    onTypeListChange: (list: string[]) => void,
    onSearch: () => void
}

const Search = (props: IProps) => {
    const { alias, statusList, typeList } = props;

    const handleAliasChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onAliasChange(e.currentTarget.value);
    };

    const handleStatusChange = (e: MouseEvent<Button & HTMLButtonElement>) => {
        let value = e.currentTarget.value;

        let newStatusList = [...props.statusList];

        if (props.statusList.indexOf(value) >= 0) {
            newStatusList = props.statusList.filter(s => s != value);
        } else {
            newStatusList.push(value);
        }

        props.onStatusListChange(newStatusList);
    };

    const handleTypeChange = (e: MouseEvent<Button & HTMLButtonElement>) => {
        let value = e.currentTarget.value;

        let newTypeList = [...props.typeList];

        if (props.typeList.indexOf(value) >= 0) {
            newTypeList = props.typeList.filter(s => s != value);
        } else {
            newTypeList.push(value);
        }

        props.onTypeListChange(newTypeList);
    };

    const handleSubmit = (e: FormEvent<any>) => {
        e.preventDefault();
        e.stopPropagation();
        
        props.onSearch();
    };

    return (
        <Well bsSize='sm'>
            <Form horizontal onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12} lg={3}>
                        <FormGroup style={{ marginBottom: 0 }}>
                            <Col xs={3} componentClass={ControlLabel}>Alias:</Col>
                            <Col xs={9}>
                                <FormControl value={alias} onChange={handleAliasChange} />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={3}>
                        <FormGroup style={{ marginBottom: 0 }}>
                            <Col xs={3} componentClass={ControlLabel}>Statuses:</Col>
                            <Col xs={9}>
                                <ButtonGroup>
                                    <Button value='active' className={statusList.indexOf('active') >= 0 ? 'btn-primary' : 'btn'} onClick={handleStatusChange}>Active</Button>
                                    <Button value='inactive' className={statusList.indexOf('inactive') >= 0 ? 'btn-primary' : 'btn'} onClick={handleStatusChange}>Inactive</Button>
                                    <Button value='transplanted' className={statusList.indexOf('transplanted') >= 0 ? 'btn-primary' : 'btn'} onClick={handleStatusChange}>Transplanted</Button>
                                </ButtonGroup>
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={3}>
                        <FormGroup style={{ marginBottom: 0 }}>
                            <Col xs={3} componentClass={ControlLabel}>Type:</Col>
                            <Col xs={9}>
                                <ButtonGroup>
                                    <Button value='direct' className={typeList.indexOf('direct') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>Direct</Button>
                                    <Button value='paired' className={typeList.indexOf('paired') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>Paired</Button>
                                    <Button value='voucher' className={typeList.indexOf('voucher') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>Voucher</Button>
                                    <Button value='wlp' className={typeList.indexOf('wlp') >= 0 ? 'btn-primary' : 'btn'} onClick={handleTypeChange}>WLP</Button>
                                </ButtonGroup>
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={2}>
                        <Button bsStyle='primary' block onClick={props.onSearch}>Search</Button>
                    </Col>
                </Row>
            </Form>
        </Well>
    );
}

export default Search;